import {
  TAddressImageUpload,
  TAddressUpdate,
  TAddressCreate,
} from '@@types/address';
import { TResponseType } from '@@types/base';
import apis from '@apis/index';
import queryKeys from '@constants/query-keys';
import { MutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useAddressCreate = (
  options: MutationOptions<
    AxiosResponse<TResponseType<{}>>,
    unknown,
    TAddressCreate
  >,
) => useMutation(apis.address.createAddress, options);

export const getAddress = () =>
  useQuery([...queryKeys.ADDRESS.ALL], apis.address.fetchAddresses);

export const useChangeCurrentAddress = (
  options: MutationOptions<
    AxiosResponse<TResponseType<{}>>,
    unknown,
    { id: string }
  >,
) => useMutation(apis.address.changeCurrentAddress, options);

export const useAddressDelete = (
  options: MutationOptions<AxiosResponse<TResponseType<{}>>, unknown, string>,
) => useMutation(apis.address.deleteAddress, options);

export const useAddressUpdate = (
  options: MutationOptions<
    AxiosResponse<TResponseType>,
    unknown,
    TAddressUpdate
  >,
) => useMutation(apis.address.updateAddress, options);

export const useAddressImageUpload = (
  options: MutationOptions<
    AxiosResponse<TResponseType>,
    unknown,
    TAddressImageUpload
  >,
) => useMutation(apis.address.uploadAddressImage, options);
